import { Injectable, OnDestroy } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { switchMap } from 'rxjs/operators';
import { Observable, of, BehaviorSubject, Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnDestroy {

  user: Observable<User> = of<User>();
  isSignedIn$ = new BehaviorSubject<boolean>(false);

  private subscriptions = new Subscription();

  constructor(private afAuth: AngularFireAuth,
              private firestore: AngularFirestore,
              private router: Router) {
  
    this.user = this.afAuth.authState.pipe(switchMap(user => {
      if (user) {
        const dbUser = this.firestore.doc<User>(`users/${user.uid}`);
        this.subscriptions.add(dbUser.get().subscribe(userSnaphot => {
          if (userSnaphot.exists) {
            this.isSignedIn$.next(true);
          } else {
            this.signOut();
          }
        }));
        return dbUser.valueChanges();
      } else {
        this.isSignedIn$.next(false);
        return of<User>();
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getUser(): Observable<User> {
    return this.user;
  }

  signOut() {
    this.isSignedIn$.next(false);
    this.afAuth.signOut().then(() => {
      this.router.navigate(['/login']);
    });
  }
}

export class Roles {
  admin: boolean;
  reportAdmin: boolean;
  communityDirector: boolean;
  faithDirector: boolean;
  familyDirector: boolean;
  lifeDirector: boolean;
  membershipDirector: boolean;
  generalProgramDirector: boolean;
}
export class User {
  name: string;
  email: string;
  roles: Roles;
}
